import gql from 'graphql-tag';

export default id => {
  const getPermissionsRoleById = `getRoleById(input: {id: "${id}"})`;
  return gql`
    query {
      ${getPermissionsRoleById} {
        customerHubModules {
          index
          hubName
          moduleName
          customerModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
          orderModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
          quoteModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
          activityModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
          subscriptionModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
        }
        billingHubModules {
          index
          hubName
          moduleName
          billingModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
          invoicingModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
          ratingModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
          taxationModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
        }
        pricingHubModules {
          index
          hubName
          moduleName
          pricingModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
          bundleModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
        }
        arHubModules {
          index
          hubName
          moduleName
          arOpsModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
          paymentModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
          collectionModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
        }
        revenueHubModules {
          index
          hubName
          moduleName
          revenueModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
        }
        opsHubModules {
          index
          hubName
          moduleName
          jobsModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
          userModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
          tenantOnboardModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
          dashboardModulePermissions{
            index
            moduleName
            permission
            type
            roleLimit
          }
          reportModulePermissions{
            index
            moduleName
            permission
            type
            roleLimit
          }
          correspondenceModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
          systemParametersModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
        }
        selfCareHubModules {
          index
          hubName
          moduleName
          selfCareModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
        }
        mediationHubModules {
          index
          hubName
          moduleName
          mediationModulePermissions {
            index
            moduleName
            permission
            type
            roleLimit
          }
        }
      }
    }
  `;
};
